import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
} from "@angular/core";
import { Router } from "@angular/router";
import { GlobalVarService } from "src/app/core/services/shared/global-var.service";

@Component({
  selector: "app-layout",
  templateUrl: "./layout.component.html",
  styleUrls: ["./layout.component.scss"],
})
export class LayoutComponent implements OnInit {
  @HostListener("click") dosomething() {
    this.globalvar.responsiveContentShowAndHide.next(false);
  }

  currentpage: number = 1;
  loader = false;
  loaderText: string;
  author: string;
  inter: any;
  quote = [
    {
      text: "<b>Don’t take your parents for granted.</b> Your parents may nag you, and you may feel as if they don’t understand you. But they love you unconditionally, so appreciate them as often as you can.",
      author: "Daniel Wong",
    },
    {
      text: "<b>Getting a bad grade isn’t the end of the world.</b> In a few years, you won’t even remember most of your grades. If you get a bad grade, learn from your mistakes and prepare better for the next exam.",
      author: "Daniel Wong",
    },
    {
      text: "<b>Use the Internet as a tool for education more than entertainment.</b> The Internet can keep you entertained for hours. But with sites like Udemy, Udacity and How Stuff Works, the Internet can also make you a far more educated person.",
      author: "Daniel Wong",
    },
    {
      text: "<b>Stress is a fact of life, but it should never become a way of life.</b> This means that it’s normal to feel stressed and tired once in a while. But if you feel stressed and tired almost every day, then you need to reevaluate your life to see what you ought to be doing differently.",
      author: "Daniel Wong",
    },
    {
      text: "<b>Learn to manage your money.</b> As a student, you probably don’t have tons of money. That’s a good thing, because you can learn to spend, save, invest and give with little risk. Learn money management skills while you’re still young!",
      author: "Daniel Wong",
    },
    {
      text: "<b>Ask for help when you need it.</b> There’s no shame in asking for help. If you can’t find the answer on Google, don’t hesitate to ask your teachers or parents. They’ll be more than willing to assist you.",
      author: "Daniel Wong",
    },
    {
      text: "<b>Write things down.</b> Your brain isn’t a perfect storage device, so write things down. Use a notebook or an app like Google Keep to ensure that you don’t forget anything important. If you write things down, you’ll be a more organised and effective student.",
      author: "Daniel Wong",
    },
    {
      text: "<b>If you need motivation to study, go to the library.</b> When you’re surrounded by people who are studying, you’ll feel inspired to study. Don’t underestimate the effect your environment has on your motivation. This study tip is extremely valuable!",
      author: "Daniel Wong",
    },
    {
      text: "<b> Learn to embrace challenges rather than avoid them.</b> Choose to see challenges as fun opportunities to learn. Even if you can’t overcome the challenge, you would have still grown as a person.",
      author: "Daniel Wong",
    },
    {
      text: "<b>Don’t blame others.</b> I used to blame my teachers, parents and peers for almost every problem I faced. Don’t be like me. The sooner you stop blaming others, the sooner you’ll learn to take full responsibility for your life.",
      author: "Daniel Wong",
    },
    {
      text: "<b>Go to every single class.</b> If the class is boring, see it as an opportunity to improve your ability to focus. If the class is about a topic you’ve learned before, see it as an opportunity to review the information.",
      author: "Daniel Wong",
    },
    {
      text: "<b>Be grateful.</b> Grateful students are happy students. No matter what situation you’re in, there’s always something to be thankful for: school, friends, family, food, health, nature, technology, etc.",
      author: "Daniel Wong",
    },
    {
      text: "<b>Don’t take shortcuts.</b> It’s tempting to take shortcuts, but resist the urge to do so. The more shortcuts you take, the less you’ll learn and the less you’ll grow as a person. Don’t shortchange yourself.",
      author: "Daniel Wong",
    },
    {
      text: "<b>Be kind to yourself.</b> Do you ever tell yourself that you’re lazy, ugly, dumb or irresponsible? Would you ever say those things to your best friend? Be kind to yourself, and learn to become your own best friend. In fact, research has proven that self-compassion is a key component of success.",
      author: "Daniel Wong",
    },
    {
      text: "<b>Spend more time thinking about others than yourself.</b> If you spend most of your time thinking about yourself, you’ll be an unhappy student. No matter how many good things there are going on in your life, you’ll be tempted to ask yourself questions like “Why can’t I be as popular as her?” or “Why are my parents so strict?” Instead, focus on helping others and you’ll be a happier student.",
      author: "Daniel Wong",
    },
    {
      text: "<b>Say no without feeling guilty.</b> Leading an effective student life is all about knowing what your priorities and values are. If there are activities or opportunities that aren’t aligned with your priorities, say no with confidence.",
      author: "Daniel Wong",
    },
    {
      text: "<b>Don’t rely on others for things that are your own responsibility.</b> I used to rely on others to remember things or run errands on my behalf. But I now realise that this was irresponsible behaviour. Don’t rely on other people for things that you should handle yourself.",
      author: "Daniel Wong",
    },
    {
      text: "<b>Exercise regularly.</b> Exercise is good for your body and your brain. So if you think you don’t have time to exercise, you actually don’t have time not to exercise. Exercise will make you a healthier and more effective student.",
      author: "Daniel Wong",
    },
    {
      text: "<b>Don’t try to remember things; make them impossible to forget.</b>  One of the most important traits to develop when you’re in school is dependability. To become a dependable student, make it impossible to forget things, e.g. submitting homework, bringing a textbook to school, asking your parents to sign a consent form. Use a diary, sticky note or app to ensure that you don’t forget.",
      author: "Daniel Wong",
    },
    {
      text: "<b> Make sleep a priority.</b> Research has proven that sleep is essential for health and brain function. Make it a priority to get eight hours of sleep a night, and you’ll be a happier and better student.",
      author: "Daniel Wong",
    },
  ];

  constructor(
    private cdRef: ChangeDetectorRef,
    public globalvar: GlobalVarService,
    private router: Router
  ) {}

  ngOnInit() {
    this.globalvar.pageChange.subscribe((stepper) => {
      this.currentpage = stepper.page;
    });
  }

  onClickItem(page: number) {
    this.globalvar.change(page);
    this.router.navigate(["/home/steps/" + Number(page)]);
  }

  startLoader(quote?) {
    this.loader = true;
    if (quote) {
      this.getQuatation();
      this.cdRef.detectChanges();
      this.inter = setInterval(() => {
        this.getQuatation();
      }, 10000);
    } else {
      this.loaderText = "";
      this.author = "";
    }
  }

  stopLoader() {
    this.loader = false;
    this.cdRef.detectChanges();
    if (this.inter) {
      clearInterval(this.inter);
    }
  }
  getQuatation() {
    let quote = this.quote[Math.floor(Math.random() * this.quote.length)];
    this.loaderText = quote.text;
    this.author = "~ " + quote.author;
  }
}
